import { contactType } from 'config/contactType';
import { entityType } from 'config/entityType';
import { invitedStatus } from 'config/invitedStatus';
import SuperFetch from 'library/helpers/superFetch';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { authActions } from 'reduxStore/auth/slice';
import { Notification } from 'zComponents/atoms';
import { peopleActions } from './slice';

export function* getPerson() {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get people from the current organisation.
		const people = yield call(() => SuperFetch.get('/people'));

		if (people.statusCode === 200) {
			yield put(peopleActions.loadPersonSuccess({ orgID, data: people.data }));
		} else {
			throw Error(people.error.message || people.error || 'Failed to load  people.');
		}
	} catch (error) {
		yield put(peopleActions.loadPersonError(error));
	}
}

export function* getLockerPerson() {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get people from the current organisation.
		const people = yield call(() => SuperFetch.get('/lockers/people'));

		if (people.statusCode === 200) {
			yield put(peopleActions.loadPersonSuccess({ orgID, data: people.data }));
		} else {
			throw Error(people.error.message || people.error || 'Failed to load  people.');
		}
	} catch (error) {
		yield put(peopleActions.loadPersonError(error));
	}
}

export function* getPersonContacts({ payload }) {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get the personID from the payload
		const { personID } = payload;

		// Get the contacts of the selected person.
		const contacts = yield call(() => SuperFetch.get(`/people/${personID}/contacts`));

		if (contacts.statusCode === 200) {
			yield put(peopleActions.loadPersonContactSuccess({ orgID, data: contacts.data, personID: personID }));
		} else {
			throw Error(contacts.error.message || contacts.error || 'Failed to load person contact.');
		}
	} catch (error) {
		yield put(peopleActions.loadPersonContactError(error));
	}
}

export function* addPersonContact({ payload }) {
	try {
		// Get the personID and contactInformation from the payload
		const { personID, contactInformation } = payload;

		// Upsert the contact of the selected person.
		const addPersonContact = yield call(() =>
			SuperFetch.post(`/contact`, {
				entityID: personID,
				entityTypeID: entityType.PERSON,
				contactInformation: contactInformation,
				contactTypeID: contactType.MOBILE
			})
		);

		if (addPersonContact.statusCode === 200) {
			Notification('success', 'Contact created successfully.');
			yield put(peopleActions.addPersonContactSuccess({ personID }));
		} else {
			throw Error(addPersonContact.error.message || addPersonContact.error || 'Failed to add person contact.');
		}
	} catch (error) {
		yield put(peopleActions.addPersonContactError(error));
		Notification('error', error.message);
	}
}

//🔥 Actions after Add Person Contact Here.
export function* addPersonContactSuccess({ payload }) {
	const { personID } = payload;

	yield put(peopleActions.loadPersonContact({ personID }));
}

export function* updatePersonContact({ payload }) {
	try {
		const { personID, contactID, contactInformation } = payload;

		// Update the contact of the selected person.
		const updatePersonContact = yield call(() =>
			SuperFetch.patch(`/contact/${contactID}`, {
				contactInformation: contactInformation
			})
		);

		if (updatePersonContact.statusCode === 200) {
			yield put(peopleActions.updatePersonContactSuccess({ personID }));
			Notification('success', 'Contact updated successfully.');
		} else {
			throw Error(
				updatePersonContact.error.message || updatePersonContact.error || 'Failed to update person contact.'
			);
		}
	} catch (error) {
		yield put(peopleActions.updatePersonContactError(error));
		Notification('error', error.message);
	}
}

//🔥 Actions after Update Person Contact Here.
export function* updatePersonContactSuccess({ payload }) {
	const { personID } = payload;

	yield put(peopleActions.loadPersonContact({ personID }));
}

export function* getPersonAddress({ payload }) {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get the personID from the payload
		const { personID } = payload;

		// Get the address of the selected person.
		const addresses = yield call(() => SuperFetch.get(`/people/${personID}/address`));

		if (addresses.statusCode === 200) {
			yield put(peopleActions.loadPersonAddressSuccess({ orgID, data: addresses.data, personID }));
		} else {
			throw Error(addresses.error.message || addresses.error || 'Failed to load person address.');
		}
	} catch (error) {
		yield put(peopleActions.loadPersonAddressError(error));
	}
}

export function* getPersonBookings({ payload }) {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get the personID from the payload
		const { personID } = payload;

		// Get the bookings of the selected person.
		const bookings = yield call(() => SuperFetch.get(`/people/${personID}/bookings`));

		if (bookings.statusCode === 200) {
			yield put(peopleActions.loadPersonBookingSuccess({ orgID, data: bookings.data, personID }));
		} else {
			throw Error(bookings.error.message || bookings.error || 'Failed to load person bookings.');
		}
	} catch (error) {
		yield put(peopleActions.loadPersonBookingError(error));
	}
}

export function* getPersonTeams({ payload }) {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get the personID from the payload
		const { personID } = payload;

		// Get the teams of the selected person.
		const teams = yield call(() => SuperFetch.get(`/people/${personID}/teams`));

		if (teams.statusCode === 200) {
			yield put(peopleActions.loadPersonTeamsSuccess({ orgID, data: teams.data, personID }));
		} else {
			throw Error(teams.error.message || teams.error || 'Failed to load person teams.');
		}
	} catch (error) {
		yield put(peopleActions.loadPersonTeamsError(error));
	}
}

export function* getPersonPermissions({ payload }) {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get the personID from the payload
		const { personID } = payload;

		// Get the permissions of the selected person.
		const permissions = yield call(() => SuperFetch.get(`/people/${personID}/permissions`));

		if (permissions.statusCode === 200) {
			yield put(peopleActions.loadPersonPermissionsSuccess({ orgID, data: permissions.data, personID }));
		} else {
			throw Error(permissions.error.message || permissions.error || 'Failed to load person permissions.');
		}
	} catch (error) {
		yield put(peopleActions.loadPersonPermissionsError(error));
	}
}

export function* invitePeople() {
	try {
		// Get selectedUsers from Redux state
		const allUsers = yield select((state) => state.People.selectedUsers);

		// Filter only pending email users
		const users = allUsers.filter((person) => person.status === invitedStatus.PENDING && person.type === 'email');

		if (users.length === 0) {
			yield call(Notification, 'info', 'No pending emails to invite.');
			return;
		}

		for (const user of users) {
			try {
				yield put(
					peopleActions.updateSelectedUserStatus({
						personID: user.personID,
						status: invitedStatus.INVITING
					})
				);

				const response = yield call(() =>
					SuperFetch.post('/people', {
						email: user.email,
						...(user.siteIDs?.length ? { siteIDs: user.siteIDs } : user.siteID ? { siteID: user.siteID } : {})
					})
				);

				if (![200, 201].includes(response.statusCode) || !response.data?.personID) {
					throw new Error();
				}

				yield call(Notification, 'success', `${user.email} invited successfully.`);

				yield put(
					peopleActions.updateSelectedUserStatus({
						personID: user.personID,
						status: invitedStatus.INVITED,
						newPersonID: response.data.personID
					})
				);
			} catch {
				yield put(
					peopleActions.updateSelectedUserStatus({
						personID: user.personID,
						status: invitedStatus.PENDING
					})
				);
			}
		}

		yield put(peopleActions.invitePeopleSuccess());
	} catch (error) {
		yield call(Notification, 'error', error.message || 'An unexpected error occurred.');
		yield put(peopleActions.invitePeopleError('Failed to invite users.'));
	}
}

//🔥 Actions after Invite People Here.
export function* invitePeopleSuccess() {
	yield put(peopleActions.loadPerson());
}

//🔥 Actions People Access Only then assign teams
export function* inviteAccessOnlyPeople() {
	try {
		const allUsers = yield select((state) => state.People.selectedUsers);

		// 🔍 Only invite users with status PENDING and type 'name'
		const users = allUsers.filter((person) => person.status === invitedStatus.PENDING && person.type === 'name');

		if (users.length === 0) {
			yield call(Notification, 'info', 'No pending users to invite (Access Only).');
			return;
		}

		for (const user of users) {
			try {
				yield put(
					peopleActions.updateSelectedUserStatus({
						personID: user.personID,
						status: invitedStatus.INVITING
					})
				);

				const response = yield call(() =>
					SuperFetch.post('/people/accessOnly', {
						...(user.siteIDs?.length ? { siteIDs: user.siteIDs } : user.siteID ? { siteID: user.siteID } : {}),
						email: user.email,
						firstName: user.firstName,
						lastName: user.lastName,
						masterUserID: user.masterUserID
					})
				);

				if (![200, 201].includes(response.statusCode) || !response.data?.personID) {
					throw new Error();
				}

				yield call(
					Notification,
					'success',
					`${user.firstName} ${user.lastName} invited successfully (Access Only).`
				);

				yield put(
					peopleActions.updateSelectedUserStatus({
						personID: user.personID,
						status: invitedStatus.INVITED,
						newPersonID: response.data.personID
					})
				);
			} catch {
				yield put(
					peopleActions.updateSelectedUserStatus({
						personID: user.personID,
						status: invitedStatus.PENDING
					})
				);
			}
		}

		yield put(peopleActions.inviteAccessOnlyPeopleSuccess());
	} catch (error) {
		yield call(Notification, 'error', error.message || 'An unexpected error occurred.');
		yield put(peopleActions.inviteAccessOnlyPeopleError('Failed to invite users.'));
	}
}

//🔥 Actions after Invite Access Only People Here.
export function* inviteAccessOnlyPeopleSuccess() {
	yield put(peopleActions.loadPerson());
}

//🔥 Actions People Access Only then assign teams
export function* setAccessOnlyToZezamiiUser(action) {
	const { personID, email } = action.payload;

	try {
		// Add multiple people Promise.all
		const addAccountPerson = yield call(() => SuperFetch.patch(`/people/${personID}/zezamiiUser`, { email }));

		// Check if all people were added successfully
		if (addAccountPerson.statusCode === 200 || addAccountPerson.statusCode === 201) {
			yield put(peopleActions.setAccessOnlyToZezamiiUserSuccess());

			// Show success Notification
			Notification('success', 'Profile(s) have been set successfully.');
		} else {
			throw new Error(
				addAccountPerson.error?.message || addAccountPerson.error || 'Failed to set profile(s) as Zezamii user.'
			);
		}
	} catch (error) {
		yield put(peopleActions.setAccessOnlyToZezamiiUserError(error));
		Notification('error', error.message);
	}
}

//🔥 Actions after Invite Access Only People Here.
export function* setAccessOnlyToZezamiiUserSuccess() {
	yield put(peopleActions.loadPerson());
}

export function* updatePerson(action) {
	const { personID, data } = action.payload;

	try {
		// Get the currently selected profile's personID (used to know if the user is updating their own profile)
		const { personID: currentPersonProfileID } = yield select((state) => state.Auth.selectedProfile);

		// Send PATCH request to update person data
		const response = yield call(() => SuperFetch.patch(`/people/${personID}`, data));

		// If the response is not successful, throw an error to trigger the catch block
		if (response.statusCode !== 200) {
			throw Error(response.error || 'Failed to update person profile.');
		}

		// Dispatch success action to update state
		yield put(peopleActions.updatePersonSuccess());

		// Show success notification to the user
		Notification('success', 'Person Profile has been updated successfully.');

		// If the updated profile is the same as the currently logged-in user,
		// re-fetch their profile to refresh the UI with updated data
		if (currentPersonProfileID === personID) {
			yield put(authActions.getUserProfile());
		}
	} catch (error) {
		yield put(peopleActions.updatePersonError(error));

		// Show error notification to the user
		Notification('error', error.message);
	}
}

//🔥 Actions after Update Person Here.
export function* updatePersonSuccess() {
	yield put(peopleActions.loadPerson());
}

//✅ Person Sites
export function* updatePersonSites({ payload }) {
	try {
		const { personID, siteIDs } = payload;
		const result = yield call(() => SuperFetch.put(`/people/${personID}/sites`, { siteIDs }));
		if (result.statusCode === 200) {
			Notification('success', 'Person sites updated successfully.');
			yield put(peopleActions.loadPerson());
		} else {
			throw Error(result.error?.message || 'Failed to update person sites.');
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to update person sites.');
		yield put(peopleActions.updatePersonSitesError(error));
	}
}

export function* resetPersonPassword({ payload }) {
	const { email } = payload;

	try {
		// Public route via unAuthenticateMisc — no auth required
		const res = yield call(() => SuperFetch.post(`/resetPassword`, { email, platform: 'Dashboard' }, {}, 1));
		if (res.statusCode === 200) {
			yield put(peopleActions.resetPersonPasswordSuccess());
			Notification('success', 'Password reset email sent successfully.');
		} else {
			throw Error(res.error?.message || res.error || 'Failed to send password reset.');
		}
	} catch (error) {
		yield put(peopleActions.resetPersonPasswordError(error));
		Notification('error', error.message);
	}
}

export function* enablePerson(action) {
	const { personIDs } = action.payload;

	try {
		yield all(
			personIDs.map((personID) =>
				call(function* () {
					const res = yield call(() => SuperFetch.patch(`/people/${personID}/enablePerson`));

					if (res.statusCode !== 200) {
						throw Error(res.error?.message || `Failed to enable. Please try again.`);
					}
				})
			)
		);

		yield put(peopleActions.enablePersonSuccess());

		Notification('success', 'Profile has been enabled.');
	} catch (error) {
		yield put(peopleActions.enablePersonError(error));
		Notification('error', error.message);
	}
}

//🔥 Actions after Enable Person Here.
export function* enablePersonSuccess() {
	yield put(peopleActions.loadPerson());
}

export function* disablePerson(action) {
	const { personIDs } = action.payload;

	try {
		yield all(
			personIDs.map((personID) =>
				call(function* () {
					const res = yield call(() => SuperFetch.patch(`/people/${personID}/disablePerson`));

					if (res.statusCode !== 200) {
						throw Error(res.error?.message || `Failed to disable. Please try again.`);
					}
				})
			)
		);

		yield put(peopleActions.disablePersonSuccess());

		Notification('success', 'Profile has been disabled.');
	} catch (error) {
		yield put(peopleActions.disablePersonError(error));
		Notification('error', error.message);
	}
}

//🔥 Actions after Disable Person Here.
export function* disablePersonSuccess() {
	yield put(peopleActions.loadPerson());
}

// ✅ Handle single or multiple profile deletions
export function* deletePerson(action) {
	const { personIDs } = action.payload;

	try {
		yield all(
			personIDs.map((personID) =>
				call(function* () {
					const res = yield call(() => SuperFetch.delete(`/people/${personID}`));

					if (res.statusCode !== 200) {
						throw Error(res.error?.message || `Failed to delete. Please try again.`);
					}
				})
			)
		);

		yield put(peopleActions.deletePersonSuccess());

		Notification('success', 'Profile has been permanently deleted.');
	} catch (error) {
		yield put(peopleActions.deletePersonError(error));
		Notification('error', error.message);
	}
}

//🔥 Actions after Delete Person Here.
export function* deletePersonSuccess() {
	yield put(peopleActions.loadPerson());
}

export default function* rootSaga() {
	yield takeLatest(peopleActions.loadPerson, getPerson);
	yield takeLatest(peopleActions.loadPersonTeams, getPersonTeams);
	yield takeLatest(peopleActions.loadPersonContact, getPersonContacts);
	yield takeLatest(peopleActions.addPersonContact, addPersonContact);
	yield takeLatest(peopleActions.addPersonContactSuccess, addPersonContactSuccess);
	yield takeLatest(peopleActions.updatePersonContact, updatePersonContact);
	yield takeLatest(peopleActions.updatePersonContactSuccess, updatePersonContactSuccess);
	yield takeLatest(peopleActions.loadPersonAddress, getPersonAddress);
	yield takeLatest(peopleActions.loadPersonBooking, getPersonBookings);
	yield takeLatest(peopleActions.loadPersonPermissions, getPersonPermissions);
	yield takeLatest(peopleActions.invitePeople, invitePeople);
	yield takeLatest(peopleActions.invitePeopleSuccess, invitePeopleSuccess);
	yield takeLatest(peopleActions.inviteAccessOnlyPeople, inviteAccessOnlyPeople);
	yield takeLatest(peopleActions.inviteAccessOnlyPeopleSuccess, inviteAccessOnlyPeopleSuccess);
	yield takeLatest(peopleActions.setAccessOnlyToZezamiiUser, setAccessOnlyToZezamiiUser);
	yield takeLatest(peopleActions.setAccessOnlyToZezamiiUserSuccess, setAccessOnlyToZezamiiUserSuccess);
	yield takeLatest(peopleActions.updatePerson, updatePerson);
	yield takeLatest(peopleActions.updatePersonSuccess, updatePersonSuccess);
	yield takeLatest(peopleActions.updatePersonSites, updatePersonSites);
	yield takeLatest(peopleActions.resetPersonPassword, resetPersonPassword);
	yield takeLatest(peopleActions.enablePerson, enablePerson);
	yield takeLatest(peopleActions.enablePersonSuccess, enablePersonSuccess);
	yield takeLatest(peopleActions.disablePerson, disablePerson);
	yield takeLatest(peopleActions.disablePersonSuccess, disablePersonSuccess);
	yield takeLatest(peopleActions.deletePerson, deletePerson);
	yield takeLatest(peopleActions.deletePersonSuccess, deletePersonSuccess);
}
